// Configuration for API endpoints
// These will be populated from Terraform outputs after deployment

export const config = {
  apiUrl: import.meta.env.VITE_API_URL || 'http://localhost:3000',
  websocketUrl: import.meta.env.VITE_WEBSOCKET_URL || 'ws://localhost:3001',
  cognitoUserPoolId: import.meta.env.VITE_COGNITO_USER_POOL_ID || '',
  cognitoClientId: import.meta.env.VITE_COGNITO_CLIENT_ID || '',
};
